export default __webpack_public_path__ + "static/light-a56c14e9107e582506e731aeb899831e.png";